import { Image, ImageProps } from 'theme-ui'

const Origin = (props: ImageProps) => {
  return (
    <Image
      width={16}
      src="https://storage-logos.reserve.org/logos/ethfi.svg"
      {...props}
    />
  )
}
export default Origin
